import React from 'react'

import { useSelector } from 'react-redux'

import { ICampaignContextProps } from '@context/Campaign'
import { IMultiframeContextProps } from '@context/MultiframeControls'
import { ISubmissionContextProps } from '@context/Submission'
import { ISubmissionListFilterContextProps } from '@context/SubmissionListFilter'
import { SocialSubmissionTypes } from '@enums'
import {
  withCampaign,
  withMultiframeControls,
  withSubmission,
  withSubmissionListFilter,
} from '@hocs'
import { IApplicationState } from '@store'
import { selectHasTransactedLicense } from '@store/mediaObjects'
import { selectActiveSubmissionMediaObject } from '@store/submissions'
import { isSocialCampaign } from '@utils/campaign'
import SubmissionCardDetailsCaption from './Caption/Caption'
import SubmissionCardDetailsContent from './Content/Content'

interface IProps {
  mobile?: boolean
}

interface IInternalProps
  extends IProps,
    ISubmissionContextProps,
    ICampaignContextProps,
    ISubmissionListFilterContextProps,
    IMultiframeContextProps {}

export const SubmissionCardDetails: React.FC<IInternalProps> = ({
  submission,
  campaign,
  isFilterLicenseRelated,
  activeFrameNumber,
}) => {
  const mediaObject = useSelector((state: IApplicationState) =>
    selectActiveSubmissionMediaObject(state, submission.id, activeFrameNumber),
  )
  const mediaObjectId = mediaObject?.id
  const hasTransactedLicense = useSelector((state: IApplicationState) =>
    selectHasTransactedLicense(state, mediaObjectId),
  )

  const isContentCampaign = !isSocialCampaign(campaign)

  if (isContentCampaign || (isFilterLicenseRelated && hasTransactedLicense)) {
    return <SubmissionCardDetailsContent mediaObjectId={mediaObjectId} />
  }

  const isText = submission.social_submission_type === SocialSubmissionTypes.Text

  return isText ? null : (
    <SubmissionCardDetailsCaption
      caption={submission.caption}
      isProxy={submission.is_proxy || submission.proxy_submission}
    />
  )
}

export default withCampaign(
  withSubmissionListFilter(withSubmission(withMultiframeControls(SubmissionCardDetails))),
)
